/**
 * Client page (world-watch style): dùng chung hook useVisitorPresence với trang chính VNA2.
 * Dashboard nhận join/leave từ cả "/" và "/client" qua cùng kênh PieSocket.
 */

import { Link } from "react-router-dom";
import { useVisitorPresence } from "../hooks/use-visitor-presence";

export default function ClientPage() {
  const { status } = useVisitorPresence();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4">
      <div className="text-center max-w-lg">
        <div className="mb-6 flex items-center justify-center gap-2">
          <span className="relative flex h-3 w-3">
            <span className="absolute inline-flex h-full w-full animate-pulse rounded-full bg-primary opacity-75" />
            <span className="relative inline-flex h-3 w-3 rounded-full bg-primary" />
          </span>
          <span className="font-mono text-sm text-primary tracking-wider uppercase">
            Live Tracking Active
          </span>
        </div>
        <h1 className="mb-4 text-4xl font-bold tracking-tight text-foreground">
          Welcome, Visitor
        </h1>
        <p className="text-lg text-muted-foreground leading-relaxed">
          Your presence has been detected and is being tracked on the live dashboard in real-time.
        </p>
        <div className="mt-8 rounded-lg border border-border bg-card p-4">
          <p className="font-mono text-xs text-muted-foreground">{status}</p>
        </div>
        <p className="mt-6 text-sm text-muted-foreground">
          <Link to="/dashboard" className="text-primary hover:underline">
            Call Monitor
          </Link>
          {" · "}
          <Link to="/" className="text-primary hover:underline">
            Voicebot
          </Link>
        </p>
      </div>
    </div>
  );
}
